module.exports = __webpack_public_path__ + "static/media/newSup.93d509a0.png";